import { DeleteOutlined, MoreOutlined, OpenAIFilled } from "@ant-design/icons";
import { Button, Dropdown, MenuProps } from "antd";
import React from "react";
import ButtonEditTrip from "../button/ButtonEditTrip";
import { ITripDetail } from "../../../../models/trip";
import { ConfirmPopup } from "../../../../utilities/swal";
import { useAppDispatch } from "../../../../lib/hook";
import { onUpdateStatusTrip } from "../../../../lib/features/trips/trips.thunk";

interface GroupButtonActionTripProps {
  trip: ITripDetail;
  onSuccess?: () => void;
}

const GroupButtonActionTrip: React.FC<GroupButtonActionTripProps> = (
  props: GroupButtonActionTripProps
) => {
  const { trip, onSuccess } = props;
  const dispatch = useAppDispatch();
  const handleUpdateStatus = async (status: string) => {
    await dispatch(onUpdateStatusTrip({ id: trip?._id, status: status })).then(
      (result) => {
        if (result?.type.includes("fulfilled")) {
          props.onSuccess && props.onSuccess();
        }
      }
    );
  };
  const items: MenuProps["items"] = [
    {
      key: "1",
      label: <ButtonEditTrip tripId={trip?._id} onSuccess={onSuccess} />,
    },
    {
      key: "2",
      label: (
        <Button
          disabled={trip?.status === "active" ? false : true}
          className="w-full"
          danger
          icon={<DeleteOutlined />}
          onClick={() => {
            ConfirmPopup(
              "Hủy chuyến đi",
              `Bạn có chắc xóa chuyến đi này không?`,
              "Ẩn",
              "Hủy",
              () => handleUpdateStatus("hidden")
            );
          }}
        >
          Ẩn
        </Button>
      ),
    },
    {
      disabled: trip?.status === "hidden" ? true : false,
      key: "3",
      label: (
        <Button
          disabled={trip?.status === "hidden" ? false : true}
          className="w-full"
          danger
          icon={<OpenAIFilled />}
          onClick={() => {
            ConfirmPopup(
              "Mở chuyến đi",
              `Bạn có chắc mở chuyến đi này không?`,
              "Mở",
              "Hủy",
              () => handleUpdateStatus("active")
            );
          }}
        >
          Mở
        </Button>
      ),
    },
  ];
  return (
    <Dropdown menu={{ items }}>
      <Button size="large" icon={<MoreOutlined />} />
    </Dropdown>
  );
};

export default GroupButtonActionTrip;
